<template>
    <CRow>
        <CCol col="12" sm="7" class="mx-auto">
            <CButton color="dribbble" class="mb-1 float-right" :to="{name: 'roles'}">
                {{ $t('back') }}
                <FaIcon icon="chevron-left" />
            </CButton>
        </CCol>
        <CCol col="12" sm="7" class="mx-auto">
            <CCard>
                <CCardBody>
                    <Form :submit="submit" :role="role" ref="createRoleRef"/>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions } from 'vuex'
import Form from './partials/Form.vue'

export default {
    name: 'Create',

    components: {
        Form,
    },

    data() {
        return {
            role: {
                name: '',
                plural_name: '',
                slug: '',
                is_admin: false,
            }
        }
    },

    methods: {
        ...mapActions('role', [
            'create'
        ]),
        submit() {
            this.create(this.role).then(() => {
                this.$router.push({name: 'roles'})
            }).catch(response => {
                if (response.data) {
                    this.$refs.createRoleRef.$refs.form.setErrors(response.data)
                }
                this.$refs.createRoleRef.$refs.form.setErrors(response.data)
                this.$refs.createRoleRef.errMessage = this.$t('tags.' + response.tag)
            })
        }
    }
}
</script>